import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-sky-dashboard',
  templateUrl: './sky-dashboard.component.html',
  styleUrls: ['./sky-dashboard.component.scss']
})
export class SkyDashboardComponent {
  @Input() scope;
}
